import React from "react";
import { Link } from 'react-router-dom';
import fsiLogo from '@/Assets/fsi-logo 3.png'
import PageTitleTemplate from "@/Components/FSI/Templates/page-title-template";
import Card from '@/Components/Surface/Card';
import Stack from "@/Components/DataDisplay/Stack";
import LoadingDialog from "@/Components/Feedback/LoadingDialog";
import TextField from "@/Components/Inputs/TextField";
import Button from "@/Components/Inputs/Button";
import DatePickerManual from "@/Components/FSI/Templates/DatePickerManual";
import Radio from "@/Components/Inputs/Radio";
import DataTable from "@/Components/DataDisplay/DataTable";
import Pagination from "@/Components/Navigation/Pagination";
import Tooltip from "@/Components/DataDisplay/Tooltip";
import WideTemplate from "@/Pages/Private/WideTemplate";
import { Accordion, AccordionDetails } from "@/Components/Surface/Accordion";
import Select from "@/Components/Inputs/Select";
import SelectOption from "@/Components/Inputs/SelectOption";
import { exportToExcel } from 'react-json-to-excel';
import { ChevronDownIcon } from "@/Icons";
import Menu from "@/Components/Navigation/Menu";
import MenuItem from "@/Components/Navigation/MenuItem";
import moment from "moment";
import { toFSIDatetimeFormat } from "@/Helpers/timezones";

import { getAllDeliveries, getAllDeliveriesForExport } from "@/Services/delivery_services";
import { getAllPersonnelRoutes } from "@/Services/routes_services";

import withContext from "@/Helpers/withContext";
import { useDeliveryContext } from "@/Store/Providers/delivery_provider";
import { requestCachePageData, requestSaveQueryInformation } from "@/Store/Actions/delivery_action";
import ImgIcon from "@/Icons/ImgIcon";
const RowsPerPageOptions = [10, 20, 50, 100];

const TableColumns = [
    {
        field: 'DeliveryId',
        label: 'Delivery ID',
        fluid: true
    },
    {
        field: 'CompanyName',
        label: 'Company Name',
        fluid: true
    },
    {
        field: 'Route',
        label: 'Route',
        width: 100,
        style: { minWidth: 'unset' }
    },
    {
        field: 'ZIP Code',
        label: 'ZipCode',
        width: 100,
        style: { minWidth: 'unset' }
    },
    {
        field: 'RecipientPrintedName',
        label: 'Printed Name',
        fluid: true
    },
    {
        field: 'DeliveryDate',
        label: 'Delivery Date',
        width: 150,
        style: { minWidth: 'unset' }
    },
    {
        field: '',
        label: '',
        width: 34,
        style: { minWidth: 'unset'},
        sortable: false
    }
    ,
    {
        field: '',
        label: '',
        width: 50,
        style: { minWidth: 'unset' },
        sortable: false
    }
];

class DeliveryInquiry extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoadingDialogOpen: false,
            userName: '',
            invoice: '',
            manifest: '',
            route: '',
            companyName: '',
            printedName: '',
            po: '',
            isDelivered: '',
            longPo: '',
            zipCode: '',
            phoneNumber: '',
            deliveryDateFrom: '',
            deliveryDateTo: '',
            routes: null,
            queryResults: null,
            pagination: {
                count: 0,
                rowsPerPage: RowsPerPageOptions[0],
                currentPage: 0
            },
            isInvalidDateRange : false
        };
    }

    cancelClickHandler = () => {
        this.setState({
            userName: '',
            invoice: '',
            manifest: '',
            route: '',
            companyName: '',
            printedName: '',
            po: '',
            isDelivered: '',
            longPo: '',
            zipCode: '',
            phoneNumber: '',
            deliveryDateFrom: '',
            deliveryDateTo: '',
            isInvalidDateRange : false
        });
    };

    confirmClickHandler = async () => {
        const _fromDate = new Date(this.state.deliveryDateFrom);
        const _toDate = new Date(this.state.deliveryDateTo);
        if(_fromDate > _toDate) {
            return this.setState({
                isInvalidDateRange : true
            });
        }

        await this.getPaginatedDeliveriesFromApi(0, RowsPerPageOptions[0]);
    };

    handleTextFieldChange = event => {
        const target = event?.target;
        const name = target?.name;
        const value = target?.value ?? '';

        if (name) {
            this.setState({
                [name]: value
            });
        }
    };

    handleRouteChange = event => {
        const target = event?.target;
        const value = target?.value ?? '';

        this.setState({
            route: value
        });
    };

    handleDeliveryDateFromChange = event => {
        if (event?.singleDate) {
            this.setState({
                deliveryDateFrom: event.singleDate
            });
        }
    };

    handleDeliveryDateToChange = event => {
        if (event?.singleDate) {
            this.setState({
                deliveryDateTo: event.singleDate
            });
        }
    };

    

    handleRadioChange = event => {
        const target = event?.target;
        let value = target?.value ?? '';
        if(this.state.isDelivered === value) {
            value = ''
        }
        this.setState({
            isDelivered: value,
            deliveryDateFrom: value?.toLowerCase().trim() === 'no' ? '' : this.state.deliveryDateFrom,
            deliveryDateTo: value?.toLowerCase().trim() === 'no' ? '' : this.state.deliveryDateTo
        });
    };

    handleChangePage = async (page) => {
        if (Array.isArray(this.props?.delivery?.cachedPages)) {
            const isCachedPageFound = this.getPaginatedDeliveriesFromCache(page, this.state.pagination.rowsPerPage);
            if (isCachedPageFound) return;
        }

        await this.getPaginatedDeliveriesFromApi(page, this.state.pagination.rowsPerPage);
    };

    handleChangeRowsPerPage = async (event) => {
        const target = event?.target;
        const value = target?.value ?? this.state.pagination.rowsPerPage;
        const rowsPerPage = parseInt(value);

        if (Array.isArray(this.props?.delivery?.cachedPages)) {
            const isCachedPageFound = this.getPaginatedDeliveriesFromCache(0, rowsPerPage);
            if (isCachedPageFound) return;
        }

        await this.getPaginatedDeliveriesFromApi(0, rowsPerPage);
    };

    handleSortChange = async (sortConfig) => {
        const { currentPage, rowsPerPage } = this.state.pagination;

        if (Array.isArray(this.props?.delivery?.cachedPages)) {
            const isCachedPageFound = this.getPaginatedDeliveriesFromCache(currentPage, rowsPerPage, sortConfig);
            if (isCachedPageFound) return;
        }

        await this.getPaginatedDeliveriesFromApi(currentPage, rowsPerPage, sortConfig);
    };

    getRoutes = async () => {
        try {
            const routes = await getAllPersonnelRoutes();

            const unique = [...new Set(routes.map(item => item.Route))]; 
            if (Array.isArray(unique)) {
                this.setState({
                    routes : unique,
                    isLoadingDialogOpen : false
                });
            }
        } catch (error) {
            // Catch error
        }
    };

    jsonToCSV = (jsonObject) => {
        const array = Array.isArray(jsonObject) ? jsonObject : [jsonObject];
        const headers = Object.keys(array[0]);
        const csvRows = [];
        
        // Create CSV headers
        csvRows.push(headers.join(','));
    
        // Create CSV rows
        for (const obj of array) {
            const values = headers.map(header => obj[header]);
           

            const test = values.map(item => {
                
                if(item === null) {
                    return `""`;
                }
                if(typeof item === 'string') {
                    return `"${item}"`
                }
                return item;             
            }).join(',');

            csvRows.push(test);
        }
    
        return csvRows.join('\n');
    }

    convertToCSV = items => {
        const csvData = this.jsonToCSV(items);
       
        return csvData;
        // let csv = '';
        // // Add header
        // csv += Object.keys(items[0]).join(',') + '\n';
        // // Add rows
        // items?.forEach(item => {
            
        //     csv += Object.values(item).join(',') + '\n';
        // });
        // return csv;
    };

    

    setSavedQueryInformation = () => {
        if (this.props?.delivery?.queryInformation) {
            this.setState({
                ...this.props?.delivery?.queryInformation
            });
        }
    };

    getPaginatedDeliveriesFromApi = async (currentPage, rowsPerPage, sortConfig) => {
        const {
            key,
            direction
        } = sortConfig || {};

        const {
            userName,
            invoice,
            manifest,
            route,
            companyName,
            printedName,
            po,
            isDelivered,
            longPo,
            zipCode,
            phoneNumber,
            deliveryDateFrom,
            deliveryDateTo,
            routes
        } = this.state;

        const params = {
            Contact: userName,
            CompanyName: companyName,
            CustomerLongPO: longPo,
            InvoiceNumber: encodeURIComponent(invoice),
            RecipientPrintedName: printedName,
            ZipCode: zipCode,
            Manifest: manifest,
            CustomerPO: po,
            ContactPhone: phoneNumber,
            Route: route,
            Complete: isDelivered,
            DeliveryDateFrom: deliveryDateFrom ? moment(deliveryDateFrom).format('YYYY-MM-DD') : '',
            DeliveryDateTo: deliveryDateTo ? moment(deliveryDateTo).format('YYYY-MM-DD') : '',
            Page: currentPage,
            PageSize: rowsPerPage,
            SortBy: key || 'DeliveryId',
            SortDirection: direction?.trim().toLowerCase() === 'ascending' ? 'ASC' : 'DESC'
        };

        this.setState({
            isLoadingDialogOpen: true
        });

        try {
            const result = await getAllDeliveries(params);

            const { Count, Deliveries } = result || {};

            this.setState({
                queryResults: Deliveries,
                pagination: {
                    count: Count,
                    rowsPerPage,
                    currentPage
                }
            });

            this.props?.dispatch(requestSaveQueryInformation({
                userName,
                invoice,
                manifest,
                route,
                companyName,
                printedName,
                po,
                isDelivered,
                longPo,
                zipCode,
                phoneNumber,
                deliveryDateFrom,
                deliveryDateTo,
                queryResults: Deliveries,
                routes,
                pagination: {
                    count: Count,
                    rowsPerPage,
                    currentPage
                }
            }));

            this.props?.dispatch(requestCachePageData(
                [
                    userName, 
                    invoice,
                    manifest,
                    route,
                    companyName,
                    printedName,
                    po,
                    isDelivered,
                    longPo,
                    zipCode,
                    phoneNumber,
                    deliveryDateFrom,
                    deliveryDateTo,
                    Count?.toString(),
                    rowsPerPage?.toString(),
                    currentPage?.toString(),
                    key || 'DeliveryId',
                    direction || 'descending'
                ]?.filter(value => !!value)?.join('-'),
                Deliveries
            ));
        } catch (error) {
            // Catch error
        } finally {
            this.setState({
                isLoadingDialogOpen: false
            });
        }
    };

    getPaginatedDeliveriesFromCache = (currentPage, rowsPerPage, sortConfig) => {
        const {
            key,
            direction
        } = sortConfig || {};

        const {
            userName,
            invoice,
            manifest,
            route,
            companyName,
            printedName,
            po,
            isDelivered,
            longPo,
            zipCode,
            phoneNumber,
            deliveryDateFrom,
            deliveryDateTo,
            pagination
        } = this.state;

        const keyToFind = [
            userName, 
            invoice,
            manifest,
            route,
            companyName,
            printedName,
            po,
            isDelivered,
            longPo,
            zipCode,
            phoneNumber,
            deliveryDateFrom,
            deliveryDateTo,
            pagination.count?.toString(),
            rowsPerPage.toString(),
            currentPage?.toString(),
            key || 'DeliveryId',
            direction || 'descending'
        ]?.filter(value => !!value)?.join('-');

        const cachedPages = this.props?.delivery?.cachedPages;
        const cachedPage = cachedPages?.find(page => page?.key === keyToFind);

        if (cachedPage) {
            this.setState({
                queryResults: cachedPage?.pageData,
                pagination: {
                    ...this.state.pagination,
                    currentPage,
                    rowsPerPage
                }
            });
        }

        return cachedPage !== undefined;
    };

    getRowRenderer = rowData => {
        const {
            CompanyName,
            Route,
            ZipCode,
            RecipientPrintedName,
            // Contact
        } = rowData || {};

        return [
            this.renderDeliveryIdRowData(rowData),
            CompanyName,
            Route,
            ZipCode,
            RecipientPrintedName,
            this.renderDeliveryDateRowData(rowData),
            this.renderDriverCommentsRowData(rowData),
            this.renderProofOfDeliveryImg(rowData)
        ];
    };

    renderProofOfDeliveryImg = rowData => {
        if (!!rowData?.ImageUrl) {
            return (
                <ImgIcon/>
            );
        }

        return '';
    };

    getButtonState = () => {
        if (
            //this.state.userName.length > 0 ||
            this.state.companyName.length > 0 ||
            this.state.longPo.length > 0 ||
            this.state.invoice.length > 0 ||
            //this.state.userName.length > 0 ||
            this.state.printedName.length > 0 ||
            this.state.zipCode.length > 0 ||
            this.state.manifest.length > 0 ||
            this.state.po.length > 0 ||
            this.state.phoneNumber.length > 0 ||
            this.state.route.length > 0 ||
            this.state.isDelivered.length > 0 ||
            this.state.deliveryDateFrom.length > 0 ||
            this.state.deliveryDateTo.length > 0
        ) {
            return false;
        }

        return true;
    };

    renderLoadingDialog = () => <LoadingDialog isOpen={this.state.isLoadingDialogOpen} />;

    renderDeliveryIdRowData = rowData => {
        return <Link className="text-purple-1 font-semibold hover:underline" to={`pod-delivery-details/${encodeURIComponent(rowData?.DeliveryId)}`}>{rowData?.DeliveryId}</Link>;
    };

    renderDeliveryDateRowData = rowData => {
        if (rowData?.DeliveryDate) {
            return toFSIDatetimeFormat(rowData.DeliveryDate)
        }
        return '';
    };

    renderDriverCommentsRowData = rowData => {
        if (rowData?.DriverComments) {
            return (
                <Tooltip
                    trigger={props => (
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="shrink-0" {...props}>
                            <mask id="mask0_1053_14629" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                <rect width="24" height="24" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_1053_14629)">
                                <circle cx="12" cy="12" r="6" fill="#F6D773" />
                            </g>
                        </svg>
                    )}
                    content={rowData?.DriverComments}
                />
            );
        }

        return '';
    };

    async componentDidMount() {
        this.setSavedQueryInformation();

        if (!this.props?.delivery?.queryInformation?.routes) {

            this.setState({
                isLoadingDialogOpen: true
            }, async () => {
                await this.getRoutes();

                
            });
            
        }
    }

    downloadCSV = (event) => {
        this.setState({ anchorEl: event.currentTarget })      
    };

    downloadCurrentDataToCSV = () => {
        const csv = this.convertToCSV(this.state.queryResults);
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'delivery_inquiry.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    getAllDeliveriesFromApi = async (currentPage, rowsPerPage, sortConfig) => {
        const {
            key,
            direction
        } = sortConfig || {};

        const {
            userName,
            invoice,
            manifest,
            route,
            companyName,
            printedName,
            po,
            isDelivered,
            longPo,
            zipCode,
            phoneNumber,
            deliveryDateFrom,
            deliveryDateTo,
        } = this.state;

        const params = {
            Contact: userName,
            CompanyName: companyName,
            CustomerLongPO: longPo,
            InvoiceNumber: encodeURIComponent(invoice),
            RecipientPrintedName: printedName,
            ZipCode: zipCode,
            Manifest: manifest,
            CustomerPO: po,
            ContactPhone: phoneNumber,
            Route: route,
            Complete: isDelivered,
            DeliveryDateFrom: deliveryDateFrom ? moment(deliveryDateFrom).format('YYYY-MM-DD') : '',
            DeliveryDateTo: deliveryDateTo ? moment(deliveryDateTo).format('YYYY-MM-DD') : '',
            Page: currentPage,
            PageSize: rowsPerPage,
            SortBy: key || 'DeliveryId',
            SortDirection: direction?.trim().toLowerCase() === 'ascending' ? 'ASC' : 'DESC',
            ExportAll: true
        };

        this.setState({
            isLoadingDialogOpen: true,
        });

        try {
            const result = await getAllDeliveriesForExport(params);

            const { Deliveries } = result || {};

            this.setState({
                allData : Deliveries
            }, () => {
                    if(this.state.exportAllType === 'csv') {
                        const csv = this.convertToCSV(this.state.allData);
                        const blob = new Blob([csv], { type: 'text/csv' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'All-Delivery-Inquiries.csv');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        exportToExcel(this.state.allData, 'All-Delivery-Inquiries')
                    }
                    
                
            });

            
        } catch (error) {
            // Catch error
        } finally {
            this.setState({
                isLoadingDialogOpen: false
            });
        }
    };

    downloadAllDataToCSV = async () => {
        
        this.setState({
            exportAllType : 'csv'
        }, async () => {
            await this.getAllDeliveriesFromApi(0,0,0)
        })
    }

    downloadCurrentDataToExcel = () => {
        exportToExcel(this.state.queryResults, 'Delivery-Inquiry')
    }

    downloadAllDataToExcel = async () => {
        this.setState({
            exportAllType : 'excel'
        }, async () => {
            await this.getAllDeliveriesFromApi(0,0,0)
        })
    }

    handleInputKeyDown = async (event) => {
        if(event && event.key === 'Enter' && !this.state.isLoadingDialogOpen) {
            await this.getPaginatedDeliveriesFromApi(0, RowsPerPageOptions[0]);
        }
    }

    render() {
        return (
            <div className="min-h-screen bg-grey-2">
                {this.state.isLoadingDialogOpen && this.renderLoadingDialog()}
                <div className="pod-header w-full flex items-center justify-center h-24 bg-white shadow">
                <img src={fsiLogo} className='w-[131px] h-[55px]' alt="fsi" />
            </div>
            <WideTemplate>
                    <PageTitleTemplate
                        title="Delivery Inquiry"
                        cancelHandler={this.cancelClickHandler}
                        confirmHandler={this.confirmClickHandler}
                        cancelLabel="Clear"
                        confirmLabel="Submit"
                        isDataDirty={true}
                        isConfirmButtonDisabled={this.getButtonState()}
                        isCancelButtonDisabled={this.getButtonState()}
                    />
                    <Accordion title="Query Criteria" defaultOpen={true} className='bg-white' expandIcon={<ChevronDownIcon />}>
                        <AccordionDetails>
                            <Stack direction="column" className="gap-[12px]">
                                <Stack alignItems="flex-start" className="w-full">
                                    <div className="w-full mr-[131px]">
                                        <TextField
                                            label="Company Name"
                                            name="companyName"
                                            placeholder="Enter Company Name"
                                            onChange={this.handleTextFieldChange}
                                            value={this.state.companyName}
                                            onKeyDown={this.handleInputKeyDown}
                                        />
                                    </div>
                                    <div className="w-full mr-[117px]">
                                        <TextField
                                            label="Long P.O."
                                            name="longPo"
                                            placeholder="Enter Long P.O."
                                            onChange={this.handleTextFieldChange}
                                            value={this.state.longPo}
                                            onKeyDown={this.handleInputKeyDown}
                                        />
                                    </div>
                                    <TextField
                                            label="Invoice"
                                            name="invoice"
                                            placeholder="Enter Invoice"
                                            onChange={this.handleTextFieldChange}
                                            value={this.state.invoice}
                                            onKeyDown={this.handleInputKeyDown}
                                        />
                                </Stack>
                                <Stack alignItems="flex-start" className="w-full">
                                    <div className="w-full mr-[131px]">
                                        <TextField
                                            label="Printed Name"
                                            name="printedName"
                                            placeholder="Enter Printed Name"
                                            onChange={this.handleTextFieldChange}
                                            value={this.state.printedName}
                                            onKeyDown={this.handleInputKeyDown}
                                        />
                                    </div>
                                    <div className="w-full mr-[117px]">
                                        <TextField
                                            label="ZIP Code"
                                            name="zipCode"
                                            placeholder="Enter ZIP Code"
                                            maxLength="9"
                                            onChange={this.handleTextFieldChange}
                                            value={this.state.zipCode}
                                            onKeyDown={this.handleInputKeyDown}
                                        />
                                    </div>
                                    <TextField
                                        label="Manifest"
                                        name="manifest"
                                        placeholder="Enter Manifest"
                                        onChange={this.handleTextFieldChange}
                                        value={this.state.manifest}
                                        onKeyDown={this.handleInputKeyDown}
                                    />
                                </Stack>
                                <Stack alignItems="flex-start" className="w-full">
                                    <div className="w-full mr-[131px]">
                                        <TextField
                                            label="P.O."
                                            name="po"
                                            placeholder="Enter P.O."
                                            onChange={this.handleTextFieldChange}
                                            value={this.state.po}
                                            onKeyDown={this.handleInputKeyDown}
                                        />
                                    </div>
                                    <div className="w-full mr-[117px]">
                                        <TextField
                                            label="Phone Number"
                                            name="phoneNumber"
                                            placeholder="Enter Phone Number"
                                            onChange={this.handleTextFieldChange}
                                            value={this.state.phoneNumber}
                                            onKeyDown={this.handleInputKeyDown}
                                        />
                                    </div>
                                    <div className="textfield w-full">

                                    </div>
                                </Stack>
                                <Stack alignItems="flex-start" className="w-full">
                                    <Select
                                        label="Route"
                                        searchable
                                        placeholder="Select a Route"
                                        className="w-full mr-[131px]"
                                        disabled={!this.state.routes}
                                        value={this.state.route}
                                        onChange={this.handleRouteChange}
                                    >
                                        {Array.isArray(this.state.routes) && this.state.routes?.map(Route => {
                                            return (
                                                <SelectOption
                                                    key={Route}
                                                    value={Route}
                                                >
                                                    {Route}
                                                </SelectOption>
                                            );
                                        })}
                                    </Select>
                                    <Stack direction="column" alignItems="flex-start" className="w-full mr-[117px] gap-[16px]">
                                        <p className="text-12 font-semibold">Delivered</p>
                                        <Stack justifyContent="flex-start" className="w-full gap-[12px]">
                                            <Radio
                                                label="Yes"
                                                checked={this.state.isDelivered.toLowerCase().trim() === 'yes'}
                                                value="yes"
                                                onClick={this.handleRadioChange}
                                            />
                                            <Radio
                                                label="No"
                                                checked={this.state.isDelivered.toLowerCase().trim() === 'no'}
                                                value="no"
                                                onClick={this.handleRadioChange}
                                            />
                                        </Stack>
                                    </Stack>
                                    <Stack direction="column" alignItems="flex-start" className="gap-[10px] w-full">
                                        <p className="text-black text-12 font-semibold">Delivery Dates</p>
                                        <Stack className="w-full gap-[10px]">
                                            <DatePickerManual
                                                singleDate
                                                withFooterActions
                                                value={this.state.deliveryDateFrom || null}
                                                initialText="MM/DD/YYYY"
                                                disablePastDates={false}
                                                disableFutureDates={false}
                                                disabled={this.state.isDelivered.toLowerCase().trim() !== 'yes'}
                                                onSetSelectedDate={this.handleDeliveryDateFromChange}
                                            />
                                            <p className="text-12 text-grey-1 font-semibold">to</p>
                                            
                                            <DatePickerManual
                                                singleDate
                                                withFooterActions
                                                value={this.state.deliveryDateTo || null}
                                                initialText="MM/DD/YYYY"
                                                disablePastDates={false}
                                                disableFutureDates={false}
                                                disabled={this.state.isDelivered.toLowerCase().trim() !== 'yes'}
                                                onSetSelectedDate={this.handleDeliveryDateToChange}
                                            />
                                        </Stack>
                                        {this.state.isInvalidDateRange && <div className="textfield-helper-text text-red text-xs">
                                            Invalid date range
                                        </div>}
                                    </Stack>
                                </Stack>
                            </Stack>
                        </AccordionDetails>
                    </Accordion>
                    {this.state.queryResults && (
                        <Card className="mt-[24px] p-[32px] gap-[16px]">
                            <Stack justifyContent="space-between" className="w-full">
                                <p className="text-16 text-black font-semibold">Query Results</p>
                                <Menu
                                className="p-2"
                                anchorEl={this.state.anchorEl}
                                open={Boolean(this.state.anchorEl)}
                                onClose={() => this.setState({ anchorEl: null })}
                            >
                                <MenuItem
                                     onClick={() => this.downloadCurrentDataToExcel()}
                                >
                                   Export Current Page (.XLSX)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => this.downloadCurrentDataToCSV()}
                                >  
                                   Export Current Page (.CSV)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => this.downloadAllDataToExcel()}
                                >
                                   Export All (.XLSX)
                                </MenuItem>
                                <MenuItem
                                    onClick={() => this.downloadAllDataToCSV()}
                                >
                                   Export All (.CSV)
                                </MenuItem>
                                
                            </Menu>                               


                                <div className="w-[95px]">
                                <Button size='full' onClick={(e) => this.downloadCSV(e)}>
                                    <div className="flex items-center gap-2">
                                    Export
                                    <div className={`duration-300 ease-in-out ${Boolean(this.state.anchorEl) ? "rotate-180" : "rotate-0"}`}>
                                        <ChevronDownIcon/>
                                    </div>
                                    </div>
                                </Button>
                                </div>
                                

                                


                            </Stack>
                            <DataTable
                                rows={this.state.queryResults}
                                rowRenderer={this.getRowRenderer}
                                columns={TableColumns}
                                sortingMode="server"
                                onSortChange={this.handleSortChange}
                            />
                            <Pagination
                                rowsPerPageOptions={RowsPerPageOptions}
                                count={this.state.pagination.count}
                                rowsPerPage={this.state.pagination.rowsPerPage}
                                page={this.state.pagination.currentPage}
                                onPageChange={this.handleChangePage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                            />
                        </Card>
                    )}
                </WideTemplate>
            </div>
        );
    }
}

export default withContext(useDeliveryContext)(DeliveryInquiry);
